// components/split/SplitChatView.js
// Layout container double panneau chat/preview — Session 20 + Session 21
// Props :
//   mode: "auto" | "manual"
//   isOpen: boolean (preview visible)
//   onToggle: () => void
//   onFullScreenChange: (bool) => void  — masque la sidebar
//   previewContent: { type, filename, url, size, content?, language? } | null
//   children: chat pane content

import React, { useState, useRef, useCallback } from 'react';
import ResizeHandle from './ResizeHandle';
import PreviewPane from './PreviewPane';

const SplitChatView = ({ mode = 'auto', isOpen, onToggle, onFullScreenChange, previewContent, onSaveAsFile, projects, currentProjectId, children }) => {
  const [chatWidth, setChatWidth] = useState(52);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const containerRef = useRef(null);

  const handleDrag = useCallback((newWidth) => {
    setChatWidth(newWidth);
  }, []);

  const handleToggleFullScreen = useCallback(() => {
    const next = !isFullScreen;
    setIsFullScreen(next);
    onFullScreenChange?.(next);
  }, [isFullScreen, onFullScreenChange]);

  const handleClose = useCallback(() => {
    if (isFullScreen) {
      setIsFullScreen(false);
      onFullScreenChange?.(false);
    }
    onToggle?.();
  }, [isFullScreen, onFullScreenChange, onToggle]);

  const showSplit = mode === 'auto' ? isOpen !== false : isOpen;

  return (
    <div
      ref={containerRef}
      className="split-chat-view"
      style={{
        display: 'flex',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <style>{`
        .split-chat-view *::-webkit-scrollbar { width: 5px; }
        .split-chat-view *::-webkit-scrollbar-track { background: transparent; }
        .split-chat-view *::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 4px; }
        .split-chat-view *::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.18); }
      `}</style>
      {/* Chat pane */}
      <div
        data-chat-pane
        style={{
          width: showSplit ? `${chatWidth}%` : '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minWidth: 0,
          transition: showSplit ? 'none' : 'width 0.3s ease',
        }}
      >
        {children}
      </div>

      {/* Resize handle + Preview */}
      {showSplit && (
        <>
          <ResizeHandle onDrag={handleDrag} containerRef={containerRef} />
          <PreviewPane
            content={previewContent}
            onClose={handleClose}
            isFullScreen={isFullScreen}
            onToggleFullScreen={handleToggleFullScreen}
            onSaveAsFile={onSaveAsFile}
            projects={projects}
            currentProjectId={currentProjectId}
          />
        </>
      )}
    </div>
  );
};

export default SplitChatView;
